import { Resources } from 'helpers/ResourceHelper';

import withAuthorizer from 'components/ui/withAuthorizer';
import BotReportList from 'components/bots/reports/BotReportList';
import CreateButton from 'components/ui/buttons/CreateButton';

const ReportTab = ({ botId }) => {
  return (
    <div className="mt-5 container" id="bot-reports-page">
      <BotReportList botId={botId} />
      <CreateButton to={`/bots/${botId}/reports/add`} />
    </div>
  );
};

export default withAuthorizer(ReportTab, [Resources.BOT_MANAGER]);
